import { FrameLanguage } from '@aipb/gulliver/env/model';

import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'fr-language-button',
  standalone: true,
  imports: [MatButtonModule, MatMenuModule, MatIconModule, TranslocoModule],
  templateUrl: './language-button.component.html',
  styleUrls: ['./language-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LanguageButtonComponent {
  @Input() currentLanguage: string;
  @Input() languages: FrameLanguage[] = [];

  @Output() changeLanguage = new EventEmitter<FrameLanguage>();
}
